// extracted by mini-css-extract-plugin
module.exports = {"label":"Divider_label__yPkYH","content":"Divider_content__1LDVD"};